module.exports = __webpack_public_path__ + "static/img/vishal.d8c2e549.jpg";